import React from 'react';
import classNames from 'classnames';
import Skeleton from 'src/components/Skeleton/Skeleton';

const TIMELINE_SKELETON_ITEM_COUNT: number = 4;

const TimelineSkeleton = () => (
  <ul className="timeline-items" aria-hidden>
    {Array.from({ length: TIMELINE_SKELETON_ITEM_COUNT }, (_, index: number) => (
      <li
        key={`timeline-skeleton-${index}`}
        className={classNames(
          'timeline-item',
          `timeline-item-${index === 0 ? 'present' : 'past'}`
        )}
      >
        <div className="timeline-bar" />
        <div className="timeline-details">
          <Skeleton variant="text" width="11rem" />
        </div>
        <div className="timeline-log">
          <Skeleton variant="text" width="9rem" />
        </div>
        <div className="timeline-log">
          <Skeleton variant="text" width="16rem" />
        </div>
        <div className="timeline-icon timeline-icon-hourglass">
          <Skeleton variant="circle" width="1.6rem" height="1.6rem" />
        </div>
      </li>
    ))}
  </ul>
);

export default TimelineSkeleton;
